module.exports = __webpack_public_path__ + "static/img/flash-betting-currently-empty.eb02b19.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/flash-betting-currently-empty.gif
// module id = kMTi
// module chunks = 12